module.exports = __webpack_public_path__ + "media/images/steps_active_left_arrow-4e040bf363943cf19ced644c4f0a26c0.png";